
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_1k57x_145",
  "slider-side": "awsui_slider-side_cqzlk_1k57x_180",
  "slider-icon": "awsui_slider-icon_cqzlk_1k57x_187",
  "slider-icon-bottom": "awsui_slider-icon-bottom_cqzlk_1k57x_193",
  "slider-icon-side": "awsui_slider-icon-side_cqzlk_1k57x_197"
};
  